import { render, staticRenderFns } from "./modalPassword.vue?vue&type=template&id=18c7823e&scoped=true&lang=pug&"
import script from "./modalPassword.vue?vue&type=script&lang=js&"
export * from "./modalPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c7823e",
  null
  
)

export default component.exports